import {
  DynamicFormConfig,
  FieldTypeEnum,
  FilterSelectFieldConfig,
  TextAreaFieldConfig,
  TextFieldConfig
} from "@mydocma/dynamic-form";

export const descriptionConfig: TextFieldConfig = {
  id: 'description',
  name: 'description',
  label: {
    text: 'MM.attachment.description'
  },
  type: FieldTypeEnum.text,
  required: false,
  maxLength: 255
}

export const commentConfig: TextAreaFieldConfig = {
  id: 'comment',
  name: 'comment',
  label: {
    text: 'MM.attachment.comment'
  },
  type: FieldTypeEnum.textarea,
  required: false,
  rows: 1,
  minRows: 1,
  maxRows: 10,
  autosize: true,
}

export const typeConfig: FilterSelectFieldConfig = {
  id: 'type',
  name: 'type',
  label: {
    text: 'MM.attachment.type'
  },
  type: FieldTypeEnum.filterSelect,
  required: false
};

export const addAttachmentFormConfig: DynamicFormConfig = {
  fields: [
    descriptionConfig,
    commentConfig,
    typeConfig
  ],
  layouts: []
};



